import { sessionStore } from 'utils/storage'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface UsersOnlineStore {
  usersOnline: number | undefined
  setUsersOnline: (count: number) => void
}

export const useUsersOnlineStore = create<UsersOnlineStore>()(
  persist(
    set => ({
      // set an initial value so we are not waiting for it
      // it's fine for us to jump visualy from this value to the real value.
      usersOnline: Math.floor(Math.random() * 80) + 1720,
      setUsersOnline: count => set({ usersOnline: count }),
    }),
    {
      name: 'users_online_store',
      storage: {
        getItem: key => {
          const value = sessionStore.getString(key) ?? null
          return value ? JSON.parse(value) : null
        },
        setItem: sessionStore.setJSON,
        removeItem: sessionStore.remove,
      },
    },
  ),
)

/**
 * Read the online count from the Zustand store without setting up a subscription.
 * Safe to use in contexts where the subscription transport is not available (e.g. landing pages).
 * The value is kept up-to-date by any active `useUsersOnlineCount` subscriber on the page.
 */
export function useUsersOnlineValue() {
  return useUsersOnlineStore(s => s.usersOnline)
}
